const ANALYTICS_PII_KEYS: ReadonlySet<string> = new Set([
    'uuid',
    'userId',
    'name',
    'technicianId',
    'vin',
    'newBin',
    'oldBin',
    'stsIdentifier',
    'tsId',
    'sts_id',
]);

export function maskPii(value?: string): string {
    if (!value) {
        return 'N/A';
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return 'N/A';
    }

    const length = trimmed.length;
    const visibleCount = length >= 10 ? 4 : length >= 7 ? 3 : 1;
    const maskedCount = Math.max(0, length - visibleCount);

    return `${'X'.repeat(maskedCount)}${trimmed.slice(-visibleCount)}`;
}

export function maskEventValue(key: string, value: unknown): unknown {
    if (Array.isArray(value)) {
        return value.map((element) =>
            element !== null && typeof element === 'object'
                ? maskEventConfig(element as Record<string, unknown>)
                : maskEventValue(key, element)
        );
    }
    if (value !== null && typeof value === 'object') {
        return maskEventConfig(value as Record<string, unknown>);
    }
    if (typeof value === 'string' && ANALYTICS_PII_KEYS.has(key) && !isAlreadyMasked(value)) {
        return maskPii(value);
    }
    return value;
}

export function isAlreadyMasked(value: string): boolean {
    // matches strings that are all-X prefix followed by 1–4 non-X characters
    return /^X+[^X]{1,4}$/.test(value);
}

export function maskEventConfig(obj: Record<string, unknown>): Record<string, unknown> {
    const result: Record<string, unknown> = {};
    for (const key of Object.keys(obj)) {
        result[key] = maskEventValue(key, obj[key]);
    }
    return result;
}

function toSnakeCase(key: string): string {
    return key.replace(/([A-Z])/g, '_$1').toLowerCase();
}

function convertValueToSnakeCase(value: unknown): unknown {
    if (Array.isArray(value)) {
        return value.map(convertValueToSnakeCase);
    }
    if (value !== null && typeof value === 'object') {
        return convertToSnakeCase(value as Record<string, unknown>);
    }
    return value;
}

export function convertToSnakeCase(obj: Record<string, unknown>): Record<string, unknown> {
    const result: Record<string, unknown> = {};
    for (const key of Object.keys(obj)) {
        result[toSnakeCase(key)] = convertValueToSnakeCase(obj[key]);
    }
    return result;
}
